import React, { useState } from "react";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import 'react-loading-skeleton/dist/skeleton.css'
const CustomTextField = ({
    label,
    type,
    placeholder,
    name,
    value,
    onBlur,
    onKeyUp,
    errors,
    onChange,
    isLoading,
    rows,
    multiline,
    min,
    inputMode,
    pattern,
    onKeyDown,
    sx = {},
    disabled,
    style = {},
    max,
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    return (
        <Box sx={{ width: "100%" }}>
             <Typography
                sx={{
                    color: "rgba(0, 0, 0, 1)",
                    fontWeight: "400",
                    textAlign: "left",
                    fontFamily: 'Outfit',
                    fontSize: { xs: "16px", sm: "18px" },
                    ...style,
                    mb:"10px",
                    textTransform: "capitalize",
                }}
            >
                {label}
            </Typography>
            {isLoading ? (
                <Skeleton height={60} />
            ) : (
                <TextField
                    sx={{
                        width: "100%",
                        
                        "& .MuiOutlinedInput-notchedOutline ": {
                            outline: "none",
                            
                        },
                        "& .MuiInputBase-root": {
                            borderRadius: "5px",
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: "16px",
                            background: "#fff",
                            fontFamily: "Outfit",
                            // height: "48px",
                        },
                        ...sx,
                    }}
                    type={type === "password" ? (showPassword ? "text" : "password") : type}
                    placeholder={placeholder}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    onKeyUp={onKeyUp}
                    multiline={multiline}
                    rows={rows}
                    onKeyDown={onKeyDown}
                    inputMode={inputMode}
                    min={min}
                    pattern={pattern}
                    disabled={disabled}
                    InputProps={{
                        maxLength: max,
                        endAdornment: type === "password" ? (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff sx={{ color: 'rgba(8, 85, 127, 1)' }} /> : <Visibility sx={{ color: 'rgba(8, 85, 127, 1)' }} />}
                                </IconButton>
                            </InputAdornment>
                        ) : null
                    }}
                />
            )}
            {errors ? (
                <Typography
                    sx={{
                        color: "red",
                        fontWeight: "400",
                        fontSize: { xs: "14px", sm: "14px" },
                        padding: '0 8px ',
                        marginTop: '4px'
                    }}
                >
                    {errors}
                </Typography>
            ) : null}
        </Box>
    );
};

export default CustomTextField;
